import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.dragging = null
    this.placeholder = null
    this.offsetY = 0

    this._onMouseMove = this.onMouseMove.bind(this)
    this._onMouseUp = this.onMouseUp.bind(this)
  }

  grab(event) {
    if (event.button !== 0) return
    event.preventDefault()

    var item = event.target.closest(".sortable-item")
    if (!item) return

    this.dragging = item
    var rect = item.getBoundingClientRect()
    this.offsetY = event.clientY - rect.top

    this.placeholder = document.createElement("div")
    this.placeholder.style.height = rect.height + "px"
    this.placeholder.style.background = "#e8f4fd"
    this.placeholder.style.border = "2px dashed #3298dc"
    this.placeholder.style.borderRadius = "4px"
    item.parentNode.insertBefore(this.placeholder, item)

    this.dragging.style.position = "fixed"
    this.dragging.style.zIndex = "9999"
    this.dragging.style.width = rect.width + "px"
    this.dragging.style.left = rect.left + "px"
    this.dragging.style.top = (event.clientY - this.offsetY) + "px"
    this.dragging.style.opacity = "0.9"
    this.dragging.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)"
    this.dragging.style.pointerEvents = "none"

    document.addEventListener("mousemove", this._onMouseMove)
    document.addEventListener("mouseup", this._onMouseUp)
  }

  onMouseMove(event) {
    if (!this.dragging) return

    this.dragging.style.top = (event.clientY - this.offsetY) + "px"

    var container = this.element
    var items = container.querySelectorAll(".sortable-item")
    var placed = false

    for (var i = 0; i < items.length; i++) {
      var item = items[i]
      if (item === this.dragging) continue

      var rect = item.getBoundingClientRect()
      var midY = rect.top + rect.height / 2

      if (event.clientY < midY) {
        container.insertBefore(this.placeholder, item)
        placed = true
        break
      }
    }

    if (!placed) {
      container.appendChild(this.placeholder)
    }
  }

  onMouseUp() {
    if (!this.dragging) return

    document.removeEventListener("mousemove", this._onMouseMove)
    document.removeEventListener("mouseup", this._onMouseUp)

    this.dragging.style.position = ""
    this.dragging.style.zIndex = ""
    this.dragging.style.width = ""
    this.dragging.style.left = ""
    this.dragging.style.top = ""
    this.dragging.style.opacity = ""
    this.dragging.style.boxShadow = ""
    this.dragging.style.pointerEvents = ""

    this.element.insertBefore(this.dragging, this.placeholder)
    this.placeholder.remove()

    this.dragging = null
    this.placeholder = null

    this.savePositions()
  }

  savePositions() {
    var container = this.element
    var url = container.getAttribute("data-sortable-url")
    if (!url) return

    var form = container.closest("form")
    var templateInput = form ? form.querySelector("[name='invoice_template_id']") : null
    var templateId = templateInput ? templateInput.value : ""

    var items = container.querySelectorAll(".sortable-item")
    var body = new URLSearchParams()

    if (templateId) {
      body.append("invoice_template_id", templateId)
    }

    for (var i = 0; i < items.length; i++) {
      var position = i + 1
      var keyEl = items[i].querySelector("[data-column-key]")
      var posInput = items[i].querySelector(".position-input")

      if (posInput) posInput.value = position

      if (keyEl) {
        body.append("columns[" + i + "][column_key]", keyEl.getAttribute("data-column-key"))
        body.append("columns[" + i + "][position]", position)
      }
    }

    var token = document.querySelector('meta[name="csrf-token"]')
    var csrfToken = token ? token.getAttribute("content") : ""

    fetch(url, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/x-www-form-urlencoded",
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: body.toString()
    })
  }
}
